import LocalizedStrings from '../LocalizedStrings';

export function localizedExternalSourceName(sourceName: string) {
  return LocalizedStrings.models.externalSource.sourceName[sourceName]?.() ?? sourceName;
}
